import firebase from 'firebase'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyCMlIUWlpmd_LRf4uqQiWcSGvRrLcNvV1A",
  authDomain: "afa-airtables.firebaseapp.com",
  databaseURL: "https://afa-airtables.firebaseio.com",
  projectId: "afa-airtables",
  storageBucket: "afa-airtables.appspot.com",
  messagingSenderId: "607873705250"
};
firebase.initializeApp(config);

export default firebase
